<ws-ace-loader [show]="loading" [size]="4" [hasOverlay]="false"></ws-ace-loader>
@if (!loading && selectedWorkflow) {
    <table class="workflows" style="margin-top: 15px;">
        @if (shouldDisplayDataHub) {
            <tr>
                <td style="font-weight: bold;">Data Hub Enabled:</td>
                <td>
                    {{ dataHubEnabled ? 'Yes' : 'No' }}
                </td>
            </tr>
        }
        <tr>
            <td style="font-weight: bold; padding-bottom: 30px;">Workflow:</td>
            <td style="padding-bottom: 30px;">
                <select class="form-select form-select-sm"
                        [(ngModel)]="selectedWorkflow"
                        (change)="workflowChanged()"
                        [disabled]="!editMode"
                        data-qa="payment-batch-workflow-select">
                    @for (workflow of availableWorkflows; track workflow; let i = $index) {
                        <option [ngValue]="workflow" [attr.data-qa]="'payment-batch-workflow-option-' + i">{{ workflow.seriesOptionName }}</option>
                    }
                </select>
            </td>
        </tr>
        @for (task of selectedWorkflow.availableTasks; track task; let i = $index) {
            <tr>
                <td>{{ task.taskName }}:</td>
                @if (editMode) {
                    <td class="pbw-user-picker">
                        <user-team-picker
                                [userId]="currentData[prefixMap[task.taskTypeId] + 'UserId']"
                                [teamId]="currentData[prefixMap[task.taskTypeId] + 'TeamId']"
                                [entityIdScope]="entity.id"
                                [entityTypeScope]="entity.type"
                                [instanceIdScope]="userSearchInstanceId"
                                (userChange)="userChanged($event, prefixMap[task.taskTypeId], task.isRequired)"
                                [parentUsers]="parentUsers"
                                [required]="task.isRequired"
                                [disabled]="!editMode"
                                [attr.data-qa]="'payment-batch-task-user-picker-' + i">
                        </user-team-picker>
                        @if (!task.isRequired) {
                            <button
                                    class="ace-btn has-icon btn-primary btn-danger"
                                    (click)="userChanged(undefined, prefixMap[task.taskTypeId], false)"
                                    style="margin:0;"
                                    [attr.data-qa]="'payment-batch-task-clear-user-' + i">
                                <i class="fa fa-trash"></i>
                            </button>
                        }
                    </td>
                }
                @if (currentData[prefixMap[task.taskTypeId] + 'User'] && (!editMode || !entity.isTopLevel)) {
                    <td>
                        {{ getDisplayName(currentData[prefixMap[task.taskTypeId] + 'User'], currentData[prefixMap[task.taskTypeId] + 'Team']) }}
                    </td>
                }
            </tr>
        }
    </table>
}
